export const GET_CMP_LEADS_RLS_SUCCESS = 'GET_CMP_LEADS_RLS_SUCCESS';
export const GET_CMP_LEADS_RLS_FAILURE = 'GET_CMP_LEADS_RLS_FAILURE';
export const CLEAN_CMP_LEADS_RLS = 'CLEAN_CMP_LEADS_RLS';
export const CMP_LEADS_RLS_INIT_STATE = null;
